module.exports = __webpack_public_path__ + "fonts/baronsans-ultrahairline-webfont.e109d9a2.woff2";